import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CHANGE_AUCTION_BET = 'AUCTION :: CHANGE_AUCTION_BET';

export type TChangeAuctionBetSource = 'input' | 'minus' | 'plus';

export interface IChangeAuctionBetActionPayload {
  bet: number;
  source: TChangeAuctionBetSource;
}

export type TChangeAuctionBetAction = IReduxAction<typeof CHANGE_AUCTION_BET, IChangeAuctionBetActionPayload>;

export const changeAuctionBet = actionGenerator<typeof CHANGE_AUCTION_BET, IChangeAuctionBetActionPayload>(
  CHANGE_AUCTION_BET,
);
